import * as Optional from "optional-js";
import {equals} from "../utils/predicates";
import {_, Backbone} from "backboneAdapter";


export default Backbone.Model.extend({
    attributeUrl: function (attributeName) {
        return `${this.urlRoot}/${this.get(this.idAttribute)}/${attributeName}`;
    },
    attributeNullUrl: function (attributeName) {
        return `${this.urlRoot}/null/${this.get(this.idAttribute)}/${attributeName}`;
    },
    attributeOptionsUrl: function (attributeName) {
        return `${this.urlRoot}/OPTIONS/${this.get(this.idAttribute)}/${attributeName}`;
    },
    newUUID: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    createClone: function (options) {
        return $.ajaxDefaultQ({
            url: `${this.urlRoot}/${this.get(this.idAttribute)}/Clone`,
            type: 'POST',
            dataType: 'json'
        });
    },
    /**
     * Stores attribute value for later syncing
     * @param attributeName {String}
     * @param value {Object}
     */
    storeAttribute: function (attributeName, value) {
        this.setNestedAttribute(attributeName, value);
    },
    /**
     *
     * @param attributeName {String}
     * @param value {Object}
     * @param callback {Function<String, Object, String>}
     * @returns {*}
     */
    saveAttribute: function (attributeName, value, callback) {
        const url = value === null ? this.attributeNullUrl(attributeName) : this.attributeUrl(attributeName);
        return $.ajaxDefaultQ({
            url: url,
            type: value === null ? 'POST' : 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(value === null ? "" : value),
            dataType: 'json'
        }).done(({outcome, data}) => {
            if (Optional.ofNullable(outcome).filter(equals("OK")).isPresent()) {
                this.setNestedAttribute(attributeName, value);
            }
            Optional.ofNullable(data)
                .map(d => d[this.idAttribute])
                .ifPresent(value => this.set(this.idAttribute, value));
            if (typeof callback == 'function') {
                callback(attributeName, value, outcome);
            }
        }).fail(() => {
            callback(attributeName, value, "NotDone");
        });
    },
    setNestedAttribute: function (attributeName, value, notify) {
        const fields = attributeName.split('.');
        const n = fields.length;
        const changedFields = _.clone(this.changed);
        let result = this;
        let prev = this;
        for (let i = 0; i < n && result !== undefined; i++) {
            let field = fields[i];
            const subfields = field.split('[');
            if (subfields.length > 1) {
                result = (result instanceof Backbone.Model) ? result.get(subfields[0]) : result[subfields[0]];
                field = parseInt(subfields[1]);
            }
            //If the last in the path, set the value
            if (i === n - 1) {
                if (result instanceof Backbone.Model)
                    result.set(field, value);
                else if (result instanceof Backbone.Collection)
                    result.at(field).set(value);
                else if (result instanceof Array && prev['setArray'] instanceof Function)
                    prev['setArray'](subfields[0], field, value);
                else
                    result[field] = value;
            } else {
                //Move onto the next part of the path
                result = (result instanceof Backbone.Model)
                    ? result.get(field)
                    : (result instanceof Backbone.Collection)
                        ? result.at(field)
                        : result[field];
            }
            prev = result;
        }
        this.changed = _.extend(changedFields, this.changed);
        if (notify) this.changed[attributeName] = value;
    },
    syncAttribute: function (attributeName) {
        this.changed = _.omit(this.changed, attributeName);
        this._previousAttributes[attributeName] = this.attributes[attributeName];
    },
    pushAttribute: function (attributeName, value, callback) {
        $.ajaxDefaultQ({
            url: this.attributeUrl(attributeName),
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(value),
            dataType: 'json'

        }).done(({outcome}) => {
            callback(attributeName, value, outcome);
        }).fail(() => {
            callback(attributeName, value, "NotDone");
        });
    }
});
